export default "__VITE_ASSET__D6_9qATQ__"